/*
 * pinia 状态管理
 *
 * @Author:    1024创新实验室-主任：卓大
 * @Date:      2022-09-06 20:58:09
 * @Wechat:    zhuda1024
 * @Email:     lab1024@163.com
 * @Copyright  1024创新实验室 ( https://1024lab.net )，Since 2012
 */
import { createPinia } from 'pinia';

export const store = createPinia();
